<template>
  <div class="phone" v-if="isShow">
    <div class="phoneBox">
      <div class="title">绑定手机号</div>
      <div class="main">
        <div class="phoneNumber">
          <span class="left">
            <span @click="showPopup">+{{cityCode}}</span>
            <img src="./../../assets/images/public/down.png" alt />
          </span>
          <span class="right">
            <input type="text" placeholder="请输入手机号" v-model="username" />
          </span>
        </div>
        <div class="sycode">
          <div class="right">
            <div class="inputBox">
              <input type="text" placeholder="请输入验证码" v-model="smscode" maxlength="4" min="4" />
            </div>
            <div class="activeBox">
              <div class="actived" v-if="showMiao">还剩{{second}}秒</div>
              <div @click="getCode" v-show="!showMiao">获取验证码</div>
            </div>
          </div>
        </div>
        <div class="submit">
          <div @click="submit">立即绑定</div>
        </div>
      </div>
      <img @click="phoneclose" class="close" src="./../../assets/images/public/rund.png" alt />
      <yd-popup v-model="show2" position="bottom" :height="Leng">
        <div
          slot="top"
          style="height:44px;line-height: 44px;font-size:0.32rem;color:#333333; font-weight:bold; border-bottom: solid 1px #f2f2f2;"
        >请选择国家/地区</div>
        <div>
          <p
            style="height:44px;line-height:44px"
            v-for="(item,index) in codeList"
            :key="index"
            @click="itemCode(item)"
          >
            <span style="display:inline-block;font-size:0.28rem;color:#4D4D4D;">{{item.country}}</span>
            <span
              style="color:#999999;font-size:0.28rem;display:inline-block;margin-left:0.20rem"
            >+{{item.countrycode}}</span>
          </p>
        </div>
        <!-- <div slot="bottom" style="height: 30px;line-height: 30px;background-color:#E8E8E8;">bottom</div> -->
      </yd-popup>
    </div>
  </div>
</template>
<script>
import router from "./../../router/index";
import { pageScroll, isBindPhone } from "./../../assets/utils/utils";
import store from "@/store/index";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    opts: {
      type: [Array, Function],
      default: () => {}
    }
  },
  data() {
    return {
      username: "",
      showMiao: false,
      second: 60,
      smscode: "",
      show2: false,
      codeList: [],
      cityCode: "86",
      Leng: "60%",
      canClick: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (isBindPhone()) {
      } else {
        this.getCityCode();
      }
    });
  },
  methods: {
    addFunction() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    getCode() {
      let that = this;

      if (this.username.trim() == "") {
        this.$dialog.toast({
          mes: "手机号不能为空",
          timeout: 1500,
          icon: "error",
          callback: () => {}
        });
        return;
      }
      this.showMiao = true;
      this.postRequest({
        service: "App.User.GetAuthCodeForRegist",
        username: this.username,
        phonepre: this.cityCode
      }).then(res => {
        if (res.data.ret == 200) {
          this.cutDown();
        } else {
          this.showMiao = false;
          this.$confirm({
            title: "提示",
            mes: res.data.msg,
            opts: [
              {
                txt: "我知道了",
                stay: true,
                color: "#ffbc00",
                callback: () => {
                  var Element = document.getElementById("confirmContent");
                  Element.parentNode.removeChild(Element);
                }
              }
            ]
          });
        }
      });
    },
    cutDown() {
      if (this.second == 0) {
        this.showMiao = false;
        this.second = 60;
      } else {
        this.second--;
        setTimeout(() => {
          this.cutDown();
        }, 1000);
      }
    },
    phoneclose() {
      this.username = "";
      this.smscode = "";
      this.cityCode = "86";
      this.close();
    },
    submit() {
      let that = this;
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;

      if (this.smscode.trim() == "") {
        this.$dialog.toast({
          mes: "请填写正确的验证码",
          timeout: 1500,
          icon: "error",
          callback: () => {}
        });
        return;
      } else if (this.smscode.trim().length <= 3) {
        this.$dialog.toast({
          mes: "验证码错误",
          timeout: 1500,
          icon: "error",
          callback: () => {}
        });
        return;
      }
      if (this.canClick) {
        this.canClick = false;
      } else {
        return;
      }

      var obj = {
        service: "App.User.RegistByOpenId",
        username: this.username,
        smscode: this.smscode,
        openid: localStorage.getItem("openid"),
        unionid: localStorage.getItem("unionid"),
        nickname: localStorage.getItem("nickname"),
        avatar: localStorage.getItem("avatar"),
        sex: localStorage.getItem("sex"),
        client: `wx:${localStorage.getItem("openid")}`,
        phonepre: this.cityCode
      };
      this.postRequest(obj).then(res => {
        var data = res.data;
        if (data.ret != 200) {
          this.$dialog.toast({
            mes: res.data.msg,
            timeout: 1500
          });
          this.canClick = true;
        } else {
          localStorage.setItem("nickname", data.data.nickname);
          localStorage.setItem("token", data.data.token);
          localStorage.setItem("user_id", data.data.user_id);
          localStorage.setItem("avatar", data.data.avatar);

          store.commit("setUser", data.data.user_id);
          console.log(data);
          this.close();
          this.canClick = true;
        }
      });
    },
    onBrowserBack() {
      this.close();
      return;
      // this.
      // 这里写点击返回键时候的事件
      // 比如判断需求执行back()或者go(-2)或者PopupShow=false隐藏弹框
    },
    itemCode(item) {
      //  this.$root.cityCode=item.countrycode;
      this.$root.cityCode = item.countrycode;
      this.$root.show2 = false;
      pageScroll.lock();
    },
    getCityCode() {
      this.postRequest({
        service: "App.Pubfile_CountryCode.GetList"
      }).then(res => {
        var data = res.data;
        this.codeList = data.data;
        if (
          this.codeList.length >
          parseInt((window.screen.height * 0.6) / 44) - 1
        ) {
          this.Leng = "60%";
        } else {
          // this.Leng = (this.codeList.length + 1) * 44 + "px";
        }
      });
    },
    showPopup() {
      this.show2 = true;
      pageScroll.unlock();
    }
  },
  destroyed() {
    // window.removeEventListener("popstate", this.onBrowserBack, false);
  }
};
</script>
<style lang="less" scoped>
.phone {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  .phoneBox {
    width: 6rem;
    height: 4.5rem;
    text-align: center;
    background: #fff;
    border-radius: 10px;
    position: relative;
    .close {
      position: absolute;
      top: -0.8rem;
      right: 0;
      height: 0.6rem;
    }
    .title {
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.32rem;
      border-bottom: solid 1px #f2f2f2;
    }
    .main {
      text-align: left;
      padding: 0.3rem 0.5rem;
      .phoneNumber {
        display: flex;
        align-items: center;
        padding-bottom: 0.1rem;
        border-bottom: solid 1px #f2f2f2;
        .left {
          font-size: 0.28rem;
          display: flex;
          align-items: center;
          color: #999999;
          img {
            width: 0.4rem;
            height: 0.4rem;
          }
        }
        .right {
          input {
            border: none;

            font-size: 0.28rem;
            width: 3.4rem;
            padding-left: 0.1rem;
          }
        }
      }
      .sycode {
        margin-top: 0.5rem;
        border-bottom: solid 1px #f2f2f2;
        padding-bottom: 0.1rem;
        .right {
          display: flex;
          align-items: center;
          overflow: hidden;
          .inputBox {
            flex: 1;
            overflow: hidden;
            input {
              border: none;
              font-size: 0.28rem;
            }
          }
          .activeBox {
            div {
              font-size: 0.28rem;

              &.actived {
                color: #b3b3b3;
              }
            }
          }
        }
      }
      .submit {
        margin-top: 0.5rem;
        text-align: center;
        div {
          width: 2rem;
          padding: 0.2rem 0.2rem;
          background: #ffdc00;
          margin: 0 auto;
          border-radius: 0.2rem;
          font-size: 0.32rem;
          color: #1a1a1a;
        }
      }
    }
  }
}
</style>

